import React from 'react';
import { Paper, PaperProps } from '@mui/material';

interface GlassmorphismCardProps extends PaperProps {
  children: React.ReactNode;
  intensity?: 'light' | 'medium' | 'strong';
}

const GlassmorphismCard: React.FC<GlassmorphismCardProps> = ({ 
  children, 
  intensity = 'medium',
  sx,
  ...props 
}) => {
  const intensityMap = {
    light: {
      background: 'rgba(255, 255, 255, 0.9)',
      backdropFilter: 'blur(8px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
    },
    medium: {
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(16px)',
      border: '1px solid rgba(255, 255, 255, 0.3)',
    },
    strong: {
      background: 'rgba(255, 255, 255, 0.98)',
      backdropFilter: 'blur(24px)',
      border: '1px solid rgba(255, 255, 255, 0.4)',
    },
  };

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
        ...intensityMap[intensity],
        ...sx,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

export default GlassmorphismCard;
